"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _excluded = ["label", "loading"];

var _templateObject, _templateObject2, _templateObject3;

var StyledTypography = (0, _styledComponents.default)(_material.Typography)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n&& {\n  font-size: 18px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n}\n"])));
/* istanbul ignore next */

var StyledButton = (0, _styledComponents.default)(_material.Button)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: 40px;\n  text-transform: none;\n\n  &.MuiButton-contained {\n    box-shadow: none;\n    border-radius: 20px;\n    opacity: unset;\n    border: 1px solid ", ";\n\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    &.Mui-disabled {\n      color: ", ";\n      background-color: ", ";\n      opacity: 0.4;\n      pointer-events: unset;\n      cursor: not-allowed;\n    }\n  }\n\n  &.MuiButton-outlined {\n    box-shadow: none;\n    border-radius: 20px;\n    border: 1px solid ", ";\n\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    &.Mui-disabled {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n      pointer-events: unset;\n      cursor: not-allowed;\n      opacity: 0.4;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color;
  return color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main;
}, function (_ref2) {
  var theme = _ref2.theme,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'primary' : _ref2$color;
  return color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.color.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.color.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme,
      _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? 'primary' : _ref6$color;
  return color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.color.white;
}, function (_ref8) {
  var theme = _ref8.theme,
      _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? 'primary' : _ref8$color;
  return color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.primary.main;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.color.white;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.primary.main;
});
var StyledCircularProgress = (0, _styledComponents.default)(_material.CircularProgress)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.color.white;
});

var SACDButton = function SACDButton(_ref13) {
  var label = _ref13.label,
      loading = _ref13.loading,
      rest = (0, _objectWithoutProperties2.default)(_ref13, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledButton, Object.assign({
    variant: "contained",
    endIcon: loading && /*#__PURE__*/_react.default.createElement(StyledCircularProgress, {
      size: 24
    })
  }, rest), label && /*#__PURE__*/_react.default.createElement(StyledTypography, null, label));
};

SACDButton.defaultProps = {
  label: '',
  loading: false
};
var _default = SACDButton;
exports.default = _default;